export const SourceTypes = {
  MOSAIC: 'mosaic',
  IMAGE: 'image',
};

export const TargetTypes = {
  MOSAIC: 'mosaic',
  COLLECTION: 'collection',
};

/**
 * Generate a lookup of class colors based on a feed's `outputClasses` property.
 *
 * @typedef {Object} [feed] A feed object.
 * @return {Object|null} A lookup of colors by class name.
 */
export function getClassColorLookup(feed) {
  let lookup = null;
  if (feed && feed.outputClasses) {
    lookup = {};
    for (const outputClass of feed.outputClasses) {
      lookup[outputClass.name] = outputClass.color;
    }
  }
  return lookup;
}
